export default [
    {
        path: '/equipment',
        name: 'equipment',
        component: () => import('@/views/equipment/equipment-list'),
    },
    {
        path: '/equipment/point',
        component: () => import('@/views/equipment/point/point'),
        name: 'point'
    },
]